var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_93_3327)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "url(#paint0_linear_93_3327)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8911 37.5525H28.8852C26.4967 37.5517 24.1498 36.9524 22.0653 35.8155L14.5 37.8L16.5246 30.4048C15.2757 28.2405 14.6186 25.7855 14.6196 23.2702C14.6228 15.4017 21.0248 9 28.8909 9C32.7086 9.00165 36.2918 10.4879 38.9862 13.1854C41.6806 15.8828 43.1637 19.4683 43.1621 23.2815C43.159 31.1483 36.7595 37.5493 28.8911 37.5525ZM22.4146 33.2322L22.8477 33.4892C24.6689 34.57 26.7565 35.1418 28.885 35.1426H28.8898C35.4276 35.1426 40.7486 29.8214 40.7513 23.281C40.7525 20.1115 39.5199 17.1314 37.2804 14.8893C35.0409 12.6472 32.0627 11.4118 28.8945 11.4107C22.3517 11.4107 17.0305 16.7314 17.0279 23.2713C17.027 25.5126 17.6541 27.6954 18.8415 29.5839L19.1235 30.0327L17.9252 34.4098L22.4146 33.2322ZM35.5913 26.3551C35.84 26.4753 36.0079 26.5565 36.0797 26.6762C36.1688 26.8249 36.1688 27.5388 35.8718 28.3719C35.5745 29.2048 34.1499 29.965 33.4648 30.0674C32.8505 30.1592 32.073 30.1975 31.2188 29.9261C30.7009 29.7618 30.0367 29.5424 29.186 29.1749C25.843 27.7315 23.5839 24.4914 23.1569 23.8791C23.127 23.8362 23.1061 23.8062 23.0944 23.7906L23.0916 23.7868C22.9028 23.535 21.6384 21.8479 21.6384 20.1018C21.6384 18.4593 22.4452 17.5984 22.8166 17.2021C22.8421 17.1749 22.8655 17.1499 22.8864 17.1271C23.2133 16.7701 23.5996 16.6808 23.8373 16.6808C24.075 16.6808 24.313 16.683 24.5208 16.6934C24.5464 16.6947 24.5731 16.6946 24.6006 16.6944C24.8084 16.6932 25.0675 16.6917 25.3231 17.3056C25.4214 17.5418 25.5652 17.892 25.717 18.2614C26.0238 19.0084 26.3628 19.8338 26.4225 19.9533C26.5116 20.1318 26.5711 20.3399 26.4522 20.578C26.4344 20.6137 26.4179 20.6474 26.4021 20.6796C26.3128 20.8618 26.2472 20.9959 26.0956 21.1728C26.036 21.2424 25.9745 21.3174 25.9129 21.3924C25.7902 21.5418 25.6675 21.6912 25.5607 21.7976C25.3822 21.9754 25.1964 22.1683 25.4044 22.5253C25.6124 22.8823 26.3281 24.05 27.3881 24.9955C28.5276 26.0119 29.518 26.4415 30.0201 26.6593C30.1181 26.7018 30.1975 26.7363 30.2558 26.7654C30.6122 26.944 30.8202 26.9141 31.0282 26.6762C31.2363 26.4382 31.9196 25.6349 32.1573 25.278C32.395 24.9211 32.6328 24.9806 32.9596 25.0995C33.2865 25.2186 35.0397 26.0812 35.3963 26.2596C35.4659 26.2945 35.531 26.3259 35.5913 26.3551Z",
    fill: "#FDFDFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_93_3327",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_93_3327"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_93_3327",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_93_3327",
    x1: 28,
    y1: 0,
    x2: 28,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25D366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25C862"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.271d82aacaf446cdc8bbd9b1f3158f5d.svg";
export { ForwardRef as ReactComponent };